export const NIL_UUID = '00000000-0000-0000-0000-000000000000';
export const NIL_UUID_2 = '00000000-0000-0000-0000-000000000001';

/** Minimum viewport height (px) for usability flow; below this the "not supported" modal is shown. */
export const MIN_USABILITY_VIEWPORT_HEIGHT = 600;

/** Stable ID for the "speak out loud" usability prompt TTS (not a real message). */
export const USABILITY_SPEECH_PROMPT_MESSAGE_ID =
  'usability-speech-prompt-tts-message-id';
